import { CommonModule } from '@angular/common';
import { ConfigurableMatTableComponent } from 'src/app/_components/shared/configurable-mat-table/configurable-mat-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgModule } from '@angular/core';
import { RTEAnalysisNotesComponent } from 'src/app/_components/shared/rich-text-editor/rte-analysis-notes/rte-analysis-notes.component';
import { RTECreateNoteComponent } from 'src/app/_components/shared/rich-text-editor/rte-create-note/rte-create-note.component';
import { RTEEditExistingNoteComponent } from 'src/app/_components/shared/rich-text-editor/rte-edit-existing-note/rte-edit-existing-note.component';
import { RTEExistingNotesComponent } from 'src/app/_components/shared/rich-text-editor/rte-existing-notes/rte-existing-notes.component';
import { RTEFormControlComponent } from 'src/app/_components/shared/rich-text-editor/rte-form-control/rte-form-control.component';
import { RTEMatFormFieldComponent } from 'src/app/_components/shared/rich-text-editor/rte-mat-form-field/rte-mat-form-field.component';
import { SharedModule } from '../shared/shared.module';
@NgModule({
  declarations: [
    RTEAnalysisNotesComponent,
    RTECreateNoteComponent,
    RTEEditExistingNoteComponent,
    RTEExistingNotesComponent,
    RTEFormControlComponent,
    RTEMatFormFieldComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  exports: [
    ConfigurableMatTableComponent,
    RTEAnalysisNotesComponent,
    RTECreateNoteComponent,
    RTEEditExistingNoteComponent,
    RTEExistingNotesComponent,
    RTEFormControlComponent,
    RTEMatFormFieldComponent,
  ]
})
export class RTEModule { }
